<template>
  <div>
    <form @submit.prevent="saveGlobal">
      <b-modal
        id="showModal"
        v-model="showModal"
        size="m"
        no-close-on-backdrop
        no-close-on-esc
        @shown="reset"
      >
        <div slot="modal-header" class="w-100">
          <font-awesome-icon icon="bars" />
          <span class="pl-2">
            {{ input ? 'Edit' : 'Add' }} Global
          </span>
        </div>
        <div>
          <b-container fluid class="pt-4">
            <b-row class="mt-2">
              <b-col md="4">
                <label>Cond</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('cond')}">
                <b-form-input
                  v-model="obj.cond"
                  v-validate="'required|alpha_dash|max:200'"
                  type="text"
                  name="cond"
                />
                <small>{{ errors.first('cond') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="4">
                <label>Code</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('code')}">
                <b-form-input
                  v-model="obj.code"
                  v-validate="'required|alpha_num|max:200'"
                  type="text"
                  name="code"
                />
                <small>{{ errors.first('code') }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="4">
                <label>Description</label>
              </b-col>
              <b-col md="8" :class="{'form-error': errors.first('description')}">
                <b-form-input
                  v-model="obj.description"
                  v-validate="'required|max:200'"
                  type="text"
                  name="description"
                />
                <small>{{ errors.first('description') }}</small>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-btn type="submit" variant="success">
            <font-awesome-icon icon="save" />
            {{ input ? 'Save' : 'Update' }} Data
          </b-btn>
          <b-btn class="float-right" variant="danger" @click="discardModal">
            <font-awesome-icon icon="times" />Discard
          </b-btn>
        </div>
      </b-modal>
    </form>
  </div>
</template>

<script>
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

export default {
  props: {
    input: {
      type: null,
      default: null
    },
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      obj: {}
    };
  },
  methods: {
    // add or edit page data
    saveGlobal() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.input === null) {
            this.$store
              .dispatch('CreateGlobal', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  'Record is created'
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          } else {
            this.$store
              .dispatch('UpdateGlobal', this.obj)
              .then(response => {
                let res = getResponseToMTH(
                  response,
                  this.$swal,
                  constants.RECORD_IS_UPDATED
                );
                if (res) {
                  this.reset();
                  this.$emit('discard-modal', true);
                }
              })
              .catch(error => {
                this.$swal(
                  constants.SOMETHING_WROING,
                  error.response.data.message,
                  constants.STATUS_ERROR
                );
              });
          }
        }
      });
    },
    discardModal() {
      this.reset();
      this.$emit('discard-modal');
    },
    // reset input field
    reset() {
      if (this.input == null) {
        this.obj = {
          id: '',
          cond: '',
          code: '',
          description: ''
        };
      } else {
        this.obj = this.input;
      }
    }
  }
};
</script>

<style>
</style>
